<template>
  <div class="modal">
    <div class="modal-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  mounted() {
    this.$emit('mounted');
  }
};
</script>

<style lang="scss" scoped>
  .modal {
    background-color: rgba($dark-raw, 0.2);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 900;

    &-container {
      @include boxShadow(0.25, true, false);
      background-color: $white-gray;
      bottom: 0.5%;
      left: 0.5%;
      position: absolute;
      right: 0.5%;
      top: 0.5%;

      @include breakpoint($large) {
        bottom: 3.5%;
        left: 3.5%;
        right: 3.5%;
        top: 3.5%;
      }
    }
  }
</style>
